module.exports = __webpack_public_path__ + "img/lea-40.73fb1ec3.png";